import {LoggedError} from './';

/**
 * Wraps any async action creator body to ensure it dispatches an Error action if anything unexpected happens
 * 
 * Do NOT use this higher order function if you use try-catch inside your action creator, as error stack will be messed up.
 */
export const errorSafe = (actionCreator: any) => {
  
    const dispatchOnError = async (fn: any, dispatch: any, ...args: any[]) => {
  
      try {
  
        await fn(dispatch, ...args);
  
      } catch (err) {
  
        dispatch(new LoggedError(err));
  
      }
    };
  
    return async (dispatch: any, getState: any) => dispatchOnError(actionCreator, dispatch, getState);
};
